import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';
import Avatar from '../../../../components/Avatar';
import RemoveButton from '../../../../components/RemoveButton';
import LinkBuilder from '../../../../helpers/link-builder';
import {Role, showNoCandidateProfileDialog} from '../../../../helpers/user';

const CommentItem = props => {
  const {
    user,
    disabled,
    id,
    candidateId,
    candidateName,
    candidatePictureUrl,
    date,
    text,
    isRemoveButtonVisible,
    isReplyButtonVisible,
    isAllowedViewFullProfile,
    isAllowedViewShortProfile,
    onClickReplyHandler,
    onClickRemoveHandler,
  } = props;

  const handleClickReply = () => {
    !disabled && onClickReplyHandler(candidateName);
  };

  const handleClickRemove = () => {
    !disabled && onClickRemoveHandler(id);
  };

  const profileLink = useMemo(() => {
    if (
      !isAllowedViewFullProfile &&
      !isAllowedViewShortProfile &&
      (Role.isRecruiter(user) || Role.isCandidate(user))
    ) {
      return (
        <strong className="comment-item__author-text">{candidateName}</strong>
      );
    }

    const link =
      isAllowedViewFullProfile || isAllowedViewShortProfile
        ? LinkBuilder.getProfileLink(candidateId)
        : '#';

    return (
      <NavLink
        className="comment-item__author-link"
        to={link}
        onClick={e => {
          if (!isAllowedViewFullProfile && !isAllowedViewShortProfile) {
            showNoCandidateProfileDialog(user);
            e.preventDefault();
          }
        }}
      >
        {candidateName}
      </NavLink>
    );
  }, [user, isAllowedViewFullProfile, isAllowedViewShortProfile]);

  return (
    <div className="comment-item">
      {isRemoveButtonVisible && (
        <RemoveButton
          disabled={disabled}
          controlFunc={handleClickRemove}
          btnBg="transparent"
          btnHoverBg="#f40"
          customStyles={{
            top: '1px',
            right: '1px',
            borderColor: 'transparent',
          }}
        />
      )}
      <div className="comment-item__container">
        <div className="comment-item__visual">
          <Avatar size={38} image={candidatePictureUrl} />
        </div>

        <div className="comment-item__content">
          {profileLink}
          {` ${text}`}
          <div className="comment-item__footer">
            <span className="comment-item__date">{date}</span>
            {isReplyButtonVisible && (
              <span
                className="comment-item__reply-link"
                onClick={handleClickReply}
              >
                Reply
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CommentItem.propTypes = {
  user: PropTypes.object.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  candidateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  candidateName: PropTypes.string.isRequired,
  candidatePictureUrl: PropTypes.string,
  text: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isReplyButtonVisible: PropTypes.bool.isRequired,
  isRemoveButtonVisible: PropTypes.bool.isRequired,
  isAllowedViewFullProfile: PropTypes.bool.isRequired,
  isAllowedViewShortProfile: PropTypes.bool.isRequired,
  onClickReplyHandler: PropTypes.func.isRequired,
  onClickRemoveHandler: PropTypes.func.isRequired,
  disabled: PropTypes.func,
};

export default CommentItem;
